<script lang="ts">
  let {
    back,
    inactive,
  }: {
    back: () => void;
    inactive: boolean;
  } = $props();
</script>

<div class="h-full">
  <p>
    Thank you for clarifying. Car finance mis-selling claims only apply to PCP
    or hire-purchase agreements.
  </p>
  <p>
    If you (or a friend!) were mis-sold car finance for another vehicle, you can
    open a new case by following instructions on the next page.
  </p>
</div>

<div class="floating-footer">
  <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
  <button type="submit" class="btn btn-primary" disabled={inactive}>Request case closure</button>
</div>
